// 16:9 ratio image
export const bynder16by9Image = (url: string) => {
  if (!url) {
    return '';
  }
  const transformQuery = 'io=transform:crop,width:2400,height:1350&format=webp';
  const querySeparator = url.includes('?') ? '&' : '?';

  return `${url}${querySeparator}${transformQuery}`;
};
